import { render, staticRenderFns } from "./Terms.vue?vue&type=template&id=9ff4a726&scoped=true&"
var script = {}
import style0 from "./Terms.vue?vue&type=style&index=0&id=9ff4a726&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ff4a726",
  null
  
)

export default component.exports